export var ETitleBlockSizes = /* @__PURE__ */ ((ETitleBlockSizes2) => {
  ETitleBlockSizes2["H1"] = "H1";
  ETitleBlockSizes2["H2"] = "H2";
  ETitleBlockSizes2["H3"] = "H3";
  return ETitleBlockSizes2;
})(ETitleBlockSizes || {});
export var ESeoHeadingSize = /* @__PURE__ */ ((ESeoHeadingSize2) => {
  ESeoHeadingSize2["H1"] = "h1";
  ESeoHeadingSize2["H2"] = "h2";
  ESeoHeadingSize2["H3"] = "h3";
  ESeoHeadingSize2["H4"] = "h4";
  return ESeoHeadingSize2;
})(ESeoHeadingSize || {});
export var ETitleBlockAligment = /* @__PURE__ */ ((ETitleBlockAligment2) => {
  ETitleBlockAligment2["LEFT"] = "LEFT";
  ETitleBlockAligment2["CENTER"] = "CENTER";
  return ETitleBlockAligment2;
})(ETitleBlockAligment || {});
export var EBadgeVariants = /* @__PURE__ */ ((EBadgeVariants2) => {
  EBadgeVariants2["HIGHLIGHT"] = "highlight";
  EBadgeVariants2["ACCENT"] = "accent";
  EBadgeVariants2["PRIMARY"] = "primary";
  EBadgeVariants2["SECONDARY"] = "secondary";
  return EBadgeVariants2;
})(EBadgeVariants || {});
